module.exports = __webpack_public_path__ + "img/blog-logo-ffffff.59d6bf45.svg";